<div class="tab-section">
 

  <div class="my-tlrs-container">
    <p-table  styleClass="p-datatable-gridlines" *ngIf="removedData.length > 0" [value]="removedData" [scrollable]="true" id="StyleTable" scrollHeight="400px">
      <ng-template pTemplate="header">
        <tr>
          <th>My TLR's</th>
          <th>TLR Status</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td [ngClass]="row.cssClass">{{ row.tlr }}</td>
          <td [ngClass]="row.cssClass">{{ row.status }}</td>
          <td><a (click)="details(row)" class="link-underline">Details</a></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="text-center">No TLRs assigned to you</td>
        </tr>
      </ng-template>
    </p-table>
    <p class="MessageTitle" *ngIf="removedData.length == 0">There are no TLR's that have been AIR (Removed)</p>
  </div>
</div>
